import React from 'react';
import classNames from 'classnames';
import Button from 'common/components/Button';

import propTypes from 'propTypes';

const Submit = ({ className, disabled, isSubmitting, ...props }) => (
  <Button
    className={classNames('Form__submit-button', className)}
    disabled={isSubmitting || disabled}
    processing={isSubmitting}
    type="submit"
    {...props}
  >
    {props.children}
  </Button>
);

Submit.propTypes = {
  isSubmitting: propTypes.bool,
};

Submit.defaultProps = {
  isSubmitting: false,
};

export default Submit;



// WEBPACK FOOTER //
// ./app/javascript/common/components/Form/Submit.js